import { useState, useEffect } from "react";
import { debounce } from "lodash";

const MOBILE_BREAKPOINT = 768;

export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkWidth = () => {
            const newIsMobile = window.innerWidth < MOBILE_BREAKPOINT;
            setIsMobile(newIsMobile);
        };

        const debouncedCheckWidth = debounce(checkWidth, 250);

        checkWidth();

        window.addEventListener("resize", debouncedCheckWidth);
        return () => {
            window.removeEventListener("resize", debouncedCheckWidth);
            debouncedCheckWidth.cancel();
        };
    }, []);

    return isMobile;
};
